import { FC } from 'react';
import { UseFormRegister, FieldError } from 'react-hook-form';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  SimpleGrid,
} from '@chakra-ui/react';

import { CustomerFormFields } from 'page/CustomerPage/types/customerFormField';
import { PoseidonUrlFormBase } from '../../FormBases';

type Props = {
  register: UseFormRegister<CustomerFormFields>;
  error: FieldError | undefined;
};

/**
 * 編集モーダル用の顧客環境URLのフォームです。
 */
export const PoseidonUrlForm: FC<Props> = ({ register, error }: Props) => (
  <FormControl isInvalid={Boolean(error)}>
    <SimpleGrid templateColumns="1fr 2fr">
      <FormLabel>顧客環境URL</FormLabel>
      <PoseidonUrlFormBase register={register} />
      <FormErrorMessage>{error && error.message}</FormErrorMessage>
    </SimpleGrid>
  </FormControl>
);
